<script setup>
import { slugifyString } from '~/utils/slugify'

const props = defineProps({
  images: {
    type: Array,
    required: true,
  },
  info: {
    type: String,
    required: false,
  },
  title: {
    type: String,
    required: false,
  },
  text: {
    type: String,
    required: false,
  },
})
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-12 col-800-10">
      <div class="media-slider">
        <Slider
          :wrap-around="true"
          :show-current="true"
          :slides="props.images"
        >
          <template #default="image">
            <NuxtImg
              v-if="image.src"
              sizes="sm:340px md:440px lg:800px"
              densities="1x 2x"
              :src="image.src"
              :alt="image.alt"
              class="media-slider__image"
              format="webp"
              loading="lazy"
            />
          </template>
        </Slider>
        <hr>
      </div>
    </div>
    <div class="col-12 col-800-10 col-1200-8 content">
      <div
        v-if="props.info"
        class="equal-small-1 content__info"
      >
        {{ props.info }}
      </div>
      <h2
        v-if="props.title"
        :id="slugifyString(props.title)"
        class="scale-5 scale-5--bold-uppercase content__title"
      >
        {{ props.title }}
      </h2>
      <div
        v-if="props.text"
        class="equal-base"
        v-html="props.text"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.media-slider {
  overflow: clip;
  @media (max-width: 576px) {
    overflow: visible;
    :deep(.slider__carousel) {
      margin-left: -25px;
      margin-right: -25px;
    }
  }
  :deep(.embla__slide) {
    flex: 0 0 100%; /* Default slide covers 100%;% of the viewport */
  }
  @media (min-width: 576px) {
    :deep(.embla__slide) {
      flex: 0 0 100%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }
  @media (min-width: 700px) {
    :deep(.embla__slide) {
      flex: 0 0 100%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }
  @media (min-width: 992px) {
    :deep(.embla__slide) {
      flex: 0 0 100%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }
  @media (min-width: 1200px) {
    :deep(.embla__slide) {
      flex: 0 0 100%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }

  &__image {
    height: 60vh;
    min-height: 400px;
    max-height: clamp(400px, 27.78vw + 311.11px, 800px);
    width: 100%;
    object-fit: cover;
  }

  hr {
    color: $color-dark-01;
    opacity: 1;
    margin-top: 10px;
    margin-bottom: 0;
  }
}

.content {
  &__info {
    color: #999999;
    margin-top: 30px;
  }

  &__title {
    margin-top: 35px;
  }

  p {
    margin-top: 10px;
    margin-bottom: 0;
  }
}
</style>
